<div class="iconbox-s4 t2 color-s2 border-corner5 animate-element wow delay5 fadeZooming" data-wow-delay="0.3s">
  <div class="avatar position-relative">
    <img src="assets/images/section/perfil.jpg" alt="images">
  </div>
  <div class="content-inner">
    <h4 class="name lt-sp04 mg-b16 text-white position-relative">Let's connect:</h4>
    <div class="fl-btn btn-general">
      <a href="https://www.linkedin.com/in/naeliza/" class="text-white border-corner2">LinkedIn</a>
    </div>
  </div>
</div>
